import { faArrowRight as fasArrowRight } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { AbstractStep } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, List } from "bm-ui-kit";
import type { ReactNode } from "react";
import React from "react";
import { Card } from "react-bootstrap";
import headerImage from "../img/header.jpg";

type StepFields = {};

export class Step1 extends AbstractStep<StepFields> {
	protected renderContent(): ReactNode {
		return (
			<>
				<Card.Img src={headerImage} variant="top" width="360" height="232" alt="Széchenyi hitel" />
				<Card.Body>
					<div className="h3 font-weight-bolder text-center text-szechenyi-green text-uppercase my-2">
						<mark className="bg-szechenyi-green text-white d-block">Mennyi széchenyi hitelt</mark>
						kaphat a céged?
					</div>
					<List itemStyle="tick" variant="success" className="mt-3">
						<List.Item className="mb-0">
							<div className="d-flex">
								<div className="w-50">
									<strong>hitelösszeg:</strong>
								</div>
								<div className="w-50">
									max. <strong>500 millió Ft</strong>
								</div>
							</div>
						</List.Item>
						<List.Item className="mb-0">
							<div className="d-flex">
								<div className="w-50">
									<strong>kamat:</strong>
								</div>
								<div className="w-50">
									max. <strong>4,5% fix</strong>
								</div>
							</div>
						</List.Item>
						<List.Item className="mb-0">
							<div className="d-flex">
								<div className="w-50">
									<strong>futamidő:</strong>
								</div>
								<div className="w-50">
									max. <strong>10 év</strong>
								</div>
							</div>
						</List.Item>
					</List>
					<div className="text-center text-szechenyi-green">
						<strong>Több mint egy kalkulátor,</strong>
						<br />
						adható hitelösszeg és termékajánlat, hitelezési
						<br />
						tapasztalatok, buktatók és tudnivalók
					</div>
				</Card.Body>
				<Card.Footer className="text-center">
					<Button type="submit" icon={<FontAwesomeIcon icon={fasArrowRight} />}>
						Kalkulátor indítása
					</Button>
				</Card.Footer>
			</>
		);
	}

	protected getComponentName(): string {
		return "Step1";
	}
}
